import { Button, Card, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BillingQuery } from '../../../../../services/query';
import Swal from 'sweetalert2';
import CopyToClipboardButton from '../../../../../atomic/atoms/SCUICopyToClipboardButton/SCUICopyToClipboardButton';
import { UBILL, uopdCls } from '../userOrderProductDetails.classes';

function UserBillingInformation({ shipment, orderId, customerId }: any) {
    const { t } = useTranslation();
    const handleGetEDispatch = () => {
        let params = {
            documentNo: shipment.documentModel.eDispatchNo,
            referenceId: shipment.shippingListId,
            customerId: customerId,
            orderId: orderId,
        };
        BillingQuery.GetEDispatch(params)
            .then(async (res: any) => {
                if (res) {
                    try {
                        const pdfUrl = URL.createObjectURL(res);

                        // PDF'i indirmek için link oluştur
                        const downloadLink = document.createElement('a');
                        downloadLink.href = pdfUrl;
                        downloadLink.download = `${shipment.documentModel.eDispatchNo}.pdf`;
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);

                        // Blob URL'ini temizle
                        URL.revokeObjectURL(pdfUrl);
                    } catch (error) {
                        console.error('Error downloading PDF:', error);
                        Swal.fire(t('orderDetail.eWaybillNotFound'), ' ', 'error');
                    }
                }
            })
            .catch((error: any) => {
                Swal.fire(t('orderDetail.eWaybillNotFound'), ' ', 'error');
                console.log('Hata :>> ', error);
            });
    };

    const handleEArchiveEInvoiceNo = () => {
        let params = {
            documentNo: shipment.documentModel.eArchiveEInvoiceNo,
            referenceId: shipment.shippingListId,
            customerId: customerId,
            isSellerStore: shipment.isSellerStore,
        };
        BillingQuery.GetEArchiveEInvoice(params)
            .then(async (res: any) => {
                if (res.url) {
                    // URL ile gelen faturalar için indirme işlemi
                    const downloadLink = document.createElement('a');
                    downloadLink.href = res.url;
                    downloadLink.download = `${shipment.documentModel.eArchiveEInvoiceNo}.pdf`;
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                } else if (res.document) {
                    try {
                        const pdfData = atob(res.docPdf);
                        const pdfArray = new Uint8Array(pdfData.length);
                        for (let i = 0; i < pdfData.length; i++) {
                            pdfArray[i] = pdfData.charCodeAt(i);
                        }
                        const pdfBlob = new Blob([pdfArray], { type: 'application/pdf' });
                        const pdfUrl = URL.createObjectURL(pdfBlob);

                        // PDF'i indirmek için link oluştur
                        const downloadLink = document.createElement('a');
                        downloadLink.href = pdfUrl;
                        downloadLink.download = `${shipment.documentModel.eArchiveEInvoiceNo}.pdf`;
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);

                        // Blob URL'ini temizle
                        URL.revokeObjectURL(pdfUrl);
                    } catch (error) {
                        console.error('Error fetching PDF:', error);
                    }
                } else {
                    Swal.fire(t('orderDetail.eInvoiceoreArchiveNotFound'), ' ', 'error');
                }
            })
            .catch((error: any) => {
                Swal.fire(t('orderDetail.eInvoiceoreArchiveNotFound'), ' ', 'error');
                console.log('Hata :>> ', error);
            });
    };

    return (
        <div
            className={UBILL.root}
            style={{
                display: 'flex',
                justifyContent: 'flex-start',
                gap: '5rem',
                marginLeft: '3rem',
            }}
        >
            <Card
                className={UBILL.eInvoiceCard}
                sx={{
                    width: '350px',
                    height: 'auto',
                    padding: '3rem',
                    boxShadow: '0px -4px 6px rgba(0, 0, 0, 0.1), 0px 4px 6px rgba(0, 0, 0, 0.1)',
                }}
            >
                <CardContent
                    className={UBILL.eInvoiceContent}
                    style={{ display: 'flex', gap: '2rem', flexDirection: 'column' }}
                >
                    <Typography
                        gutterBottom
                        variant="h3"
                        component="div"
                        className={uopdCls('heading-md', UBILL.eInvoiceTitle)}
                        style={{ fontWeight: 'bold' }}
                    >
                        {`${t('orderDetail.eInvoice')}/${t('orderDetail.eArchive')}`}
                    </Typography>
                    <Typography
                        className={uopdCls('text-sm', UBILL.eInvoiceDocRow)}
                        variant="body2"
                        color="text.secondary"
                    >
                        {t('orderDetail.documentNo')} :
                        <Button
                            className={uopdCls('text-sm', UBILL.eInvoiceDocButton)}
                            style={{ marginLeft: '3px' }}
                            onClick={handleEArchiveEInvoiceNo}
                        >
                            {`${shipment.documentModel.eArchiveEInvoiceNo}`}
                        </Button>
                        <span className={UBILL.eInvoiceCopyWrap}>
                            <CopyToClipboardButton textToCopy={shipment.documentModel.eArchiveEInvoiceNo} />
                        </span>
                    </Typography>
                    {shipment.documentModel.eArchiveEInvoiceNoDate && (
                        <Typography
                            className={uopdCls('text-sm', UBILL.eInvoiceDateRow)}
                            gutterBottom
                            variant="h5"
                            component="div"
                        >
                            {t('orderDetail.date')}: {shipment.documentModel.eArchiveEInvoiceNoDateStr}
                        </Typography>
                    )}
                </CardContent>
            </Card>
            <Card
                className={UBILL.waybillCard}
                sx={{
                    width: '350px',
                    height: 'auto',
                    padding: '3rem',
                    boxShadow: '0px -4px 6px rgba(0, 0, 0, 0.1), 0px 4px 6px rgba(0, 0, 0, 0.1)',
                }}
            >
                <CardContent
                    className={UBILL.waybillContent}
                    style={{ display: 'flex', gap: '2rem', flexDirection: 'column' }}
                >
                    <Typography
                        gutterBottom
                        variant="h3"
                        component="div"
                        className={uopdCls('heading-md', UBILL.waybillTitle)}
                        style={{ fontWeight: 'bold' }}
                    >
                        {t('orderDetail.waybillNumber')}
                    </Typography>
                    <Typography
                        className={uopdCls('text-sm', UBILL.waybillDocRow)}
                        variant="body2"
                        color="text.secondary"
                    >
                        {t('orderDetail.documentNo')} :
                        <Button
                            onClick={handleGetEDispatch}
                            className={uopdCls('text-sm', UBILL.waybillDocButton)}
                        >
                            {shipment.documentModel.eDispatchNo}
                        </Button>
                        <span className={UBILL.waybillCopyWrap}>
                            <CopyToClipboardButton textToCopy={shipment.documentModel.eDispatchNo} />
                        </span>
                    </Typography>
                    {shipment.documentModel.eDispatchNoDate && (
                        <Typography
                            className={uopdCls('text-sm', UBILL.waybillDateRow)}
                            gutterBottom
                            variant="h5"
                            component="div"
                        >
                            {t('orderDetail.date')}: {shipment.documentModel.eDispatchNoDateStr}
                        </Typography>
                    )}
                </CardContent>
            </Card>
        </div>
    );
}

export default UserBillingInformation;
